import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import VideoIncreaseRes from "../../../assets/ImageEditing/images/Increase_res.jpg";
import VideoMaskByPrompt from "../../../assets/ImageEditing/images/Mask_by_prompt.jpg";
import VideoRemoveBackground from "../../../assets/ImageEditing/images/Remove_background.jpg";
import VideoSolidColor from "../../../assets/ImageEditing/images/Solid_color.jpg";
import VideoEraser from "../../../assets/ImageEditing/images/eraser.jpg";
import VideomaskVByKeyPoints from "../../../assets/ImageEditing/images/mask_by_key_points.jpg";
import { ConsoleAPICardProps } from "../../../components/Home/API/Cards/Card/ConsoleAPICard";
import ConsoleAPICards from "../../../components/Home/API/Cards/ConsoleAPICards";
import ConsoleAPILayout from "../../../components/Home/API/ConsoleAPILayout";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import LinkConstants from "../../../constants/LinkConstants";
import RouterConstants from "../../../constants/RouterConstants";

const VideoEditingApi = () => {
	const { t } = useTranslation("translation", { keyPrefix: "imageEditing.api" });
	const navigate = useNavigate();

	const rightActions = (
		<>
			<BriaButton
				buttonType="secondarySmall"
				onClick={() => navigate(RouterConstants.LABS.VIDEO_EDITING.fullPath)}
			>
				{t("headerButtons.playground")}
			</BriaButton>
		</>
	);

	const openDocs = (link: string) => window.open(link, "_blank");

	const videoEditingApiCards: ConsoleAPICardProps[] = [
		{
			image: VideoEraser,
			header: t("cards.videoEraser.header"),
			description: t("cards.videoEraser.description"),
			buttons: (
				<>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.VIDEO_EDITING.ERASER.DOCS)}
					>
						{t("cards.videoEraser.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => window.open(LinkConstants.VIDEO_EDITING.ERASER.COMFY_UI.NODE, "_blank")}
					>
						{t("common.comfyNodeBtn")}
					</BriaButton>
				</>
			),
			onClick: () => openDocs(LinkConstants.VIDEO_EDITING.ERASER.DOCS),
		},
		{
			image: VideoRemoveBackground,
			header: t("cards.videoBackgroundRemoval.header"),
			description: t("cards.videoBackgroundRemoval.description"),
			buttons: (
				<>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.VIDEO_EDITING.REMOVE_BACKGROUND.DOCS)}
					>
						{t("cards.videoBackgroundRemoval.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() =>
							window.open(LinkConstants.VIDEO_EDITING.REMOVE_BACKGROUND.COMFY_UI.NODE, "_blank")
						}
					>
						{t("common.comfyNodeBtn")}
					</BriaButton>
				</>
			),
			onClick: () => openDocs(LinkConstants.VIDEO_EDITING.REMOVE_BACKGROUND.DOCS),
		},
		{
			image: VideoSolidColor,
			header: t("cards.videoSolidBackground.header"),
			description: t("cards.videoSolidBackground.description"),
			buttons: (
				<>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.VIDEO_EDITING.REPLACE_BACKGROUND.DOCS)}
					>
						{t("cards.videoSolidBackground.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() =>
							window.open(LinkConstants.VIDEO_EDITING.REPLACE_BACKGROUND.COMFY_UI.NODE, "_blank")
						}
					>
						{t("common.comfyNodeBtn")}
					</BriaButton>
				</>
			),
			onClick: () => openDocs(LinkConstants.VIDEO_EDITING.REPLACE_BACKGROUND.DOCS),
		},
		{
			image: VideoIncreaseRes,
			header: t("cards.videoIncreaseRes.header"),
			description: t("cards.videoIncreaseRes.description"),
			buttons: (
				<>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.VIDEO_EDITING.INCREASE_RESOLUTION.DOCS)}
					>
						{t("cards.videoIncreaseRes.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() =>
							window.open(LinkConstants.VIDEO_EDITING.INCREASE_RESOLUTION.COMFY_UI.NODE, "_blank")
						}
					>
						{t("common.comfyNodeBtn")}
					</BriaButton>
				</>
			),
			onClick: () => openDocs(LinkConstants.VIDEO_EDITING.INCREASE_RESOLUTION.DOCS),
		},
		{
			image: VideoMaskByPrompt,
			header: t("cards.videoMaskByPrompt.header"),
			description: t("cards.videoMaskByPrompt.description"),
			buttons: (
				<>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.VIDEO_EDITING.MASK_BY_PROMPT.DOCS)}
					>
						{t("cards.videoMaskByPrompt.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => window.open(LinkConstants.VIDEO_EDITING.MASK_BY_PROMPT.COMFY_UI.NODE, "_blank")}
					>
						{t("common.comfyNodeBtn")}
					</BriaButton>
				</>
			),
			onClick: () => openDocs(LinkConstants.VIDEO_EDITING.MASK_BY_PROMPT.DOCS),
		},
		{
			image: VideomaskVByKeyPoints,
			header: t("cards.videoMaskByKeyPoints.header"),
			description: t("cards.videoMaskByKeyPoints.description"),
			buttons: (
				<>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.VIDEO_EDITING.MASK_BY_KEY_POINTS.DOCS)}
					>
						{t("cards.videoMaskByKeyPoints.primaryBtn")}
					</BriaButton>

					<BriaButton
						buttonType="textSmall"
						onClick={() =>
							window.open(LinkConstants.VIDEO_EDITING.MASK_BY_KEY_POINTS.COMFY_UI.NODE, "_blank")
						}
					>
						{t("common.comfyNodeBtn")}
					</BriaButton>
				</>
			),
			onClick: () => openDocs(LinkConstants.VIDEO_EDITING.MASK_BY_KEY_POINTS.DOCS),
		},
	];

	return (
		<ConsoleAPILayout rightActions={rightActions} showIntegrationKeyButton>
			<ConsoleAPICards cards={videoEditingApiCards} />
		</ConsoleAPILayout>
	);
};

export default observer(VideoEditingApi);
